// @flow

import { SwitchField } from 'src/Reshaped/Form/SwitchField';

import type { FieldSchema } from './DomainContactForm';

import { InputField } from './InputField';

export const SwitchRenderer = (field: FieldSchema): React.Node => (
  <InputField field={field}>
    {({ name, label, control, disabled, rules, help, sublabel }) => (
      <SwitchField
        key={name}
        name={name}
        label={label}
        help={help}
        control={control}
        disabled={disabled}
        rules={rules}
      >
        {sublabel}
      </SwitchField>
    )}
  </InputField>
);
